import { KeyedResource } from './keyed.resource';

export class FormResource extends KeyedResource {
  private formNameImpl: string;
  private panelNameImpl: string;

  constructor(args: any) {
    super(args, args.formName);

    const self: any = this;

    self.resourceType = 'form';

    if (self.uiResourceName) {
      const result = self.uiResourceName.split('.');
      self.formNameImpl = result[ 0 ];
      if (result.length > 1) {
        self.panelNameImpl = result[ 1 ];
      }
    }
  }

  public get formName() {
    return this.formNameImpl;
  }

  public get panelName() {
    return this.panelNameImpl;
  }
}
